import { useParams } from 'react-router';
import { useUploadPhotoInObjectPhotoGalleryMutation } from '../../api/mutations/generated/UploadPhotoInObjectPhotoGallery';
import { useRemovePhotoInObjectPhotoGalleryMutation } from '../../api/mutations/generated/RemovePhotoInObjectPhotoGallery';
import { errorToast, successToast } from 'utils/helpers/notify';
import { errorHandler } from 'utils/helpers/errorHandler';
import PhotoList from 'components/PhotoList';
import { useObject } from 'utils/api/useObject';
import { ErrorType } from 'utils/helpers/errorHandler';
import { useState } from 'react';
import Modal from 'ui/modal';

interface FileEntity {
  id: string;
  path: string;
}

interface FacilityGalleryEntity {
  id: string;
  file: FileEntity;
}

const PhotoGallery = () => {
  const { facilityId } = useParams();
  const { object } = useObject();
  const [uploadPhoto] = useUploadPhotoInObjectPhotoGalleryMutation({ refetchQueries: ['GetObject'] });
  const [removePhoto] = useRemovePhotoInObjectPhotoGalleryMutation({ refetchQueries: ['GetObject'] });
  const [selectedPhotoIds, setSelectedPhotoIds] = useState<string[]>([]);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const handleUpload = async (file: File) => {
    if (!facilityId) return;

    try {
      await uploadPhoto({
        variables: {
          input: {
            objectId: facilityId,
            photo: file,
          },
        },
      });
      successToast('Фото успешно загружено');
    } catch (err) {
      errorToast(errorHandler(err as ErrorType));
    }
  };

  const handleDelete = (photoId: string) => {
    if (!photoId) return;

    setSelectedPhotoIds(prev => {
      const newIds = prev.includes(photoId) ? prev.filter(id => id !== photoId) : [...prev, photoId];
      return newIds.filter(Boolean);
    });
  };

  const handleConfirmDelete = async () => {
    if (!facilityId || selectedPhotoIds.length === 0) return;

    try {
      await removePhoto({
        variables: {
          input: {
            objectId: facilityId,
            objectPhotoGalleryIds: selectedPhotoIds.filter(Boolean),
          },
        },
      });
      successToast('Фото успешно удалены');
      setSelectedPhotoIds([]);
      setIsDeleteModalOpen(false);
    } catch (err) {
      errorToast(errorHandler(err as ErrorType));
    }
  };

  const mappedGallery: FacilityGalleryEntity[] =
    object?.photoGallery?.map(item => ({
      id: item.id,
      file: {
        id: item.photo.id,
        path: item.photo.path,
      },
    })) || [];

  const canUploadMorePhotos = (object?.photoGallery?.length || 0) < 3;

  return (
    <div className="col-span-full xl:col-span-9 md:col-span-7">
      <PhotoList
        facilityGallery={mappedGallery}
        casingGallery={[]}
        onDownload={handleUpload}
        isDownload={canUploadMorePhotos}
        isDelete
        handleDelete={handleDelete}
        photoIds={selectedPhotoIds}
      />

      {selectedPhotoIds.length > 0 && (
        <button type="button" className="btn-reject_secondary self-end" onClick={() => setIsDeleteModalOpen(true)}>
          Удалить {selectedPhotoIds.length} фото
        </button>
      )}

      <Modal
        type="delete"
        title="Удалить фото"
        open={isDeleteModalOpen}
        onCancel={() => setIsDeleteModalOpen(false)}
        onOk={handleConfirmDelete}
      >
        Вы уверены, что хотите удалить выбранные фото?
      </Modal>
    </div>
  );
};

export default PhotoGallery;
